import { GlassTabs, GlassTabsContent } from "@/components/ui/glass-tabs";
import { useEffect, useState } from "react"
import { CompanyHeader } from "./CompanyHeader";
import type { CompanyData } from "../../config/companies/types";
import { CompanyTimeline } from "./CompanyTimeline";
import { CompanyProfile } from "./CompanyProfile";

export function CompanyPage({ companyKey }: { companyKey: string }) {
  // todo load company metadata.
  const [metadata, setMetadata] = useState<CompanyData>();
  useEffect(() => {
    fetch(`/${companyKey}/metadata.json`)
      .then(response => response.json())
      .then(data => setMetadata(data));
  }, [companyKey]);
  const [activeTab, setActiveTab] = useState<"timeline"|"profile">("timeline");
  return (
    <GlassTabs defaultValue="timeline">
      <CompanyHeader metadata={metadata} />
      <div className="h-16 w-full" />
      <GlassTabsContent value="timeline" className="mt-2">
        <CompanyTimeline metadata={metadata} companyKey={companyKey} />
      </GlassTabsContent>
      <GlassTabsContent value="profile">
        <CompanyProfile metadata={metadata} />
      </GlassTabsContent>
    </GlassTabs>
  )
}